// Whether the end of a tournament may be shown yet. The server marks a tournament finished the
// moment the last hand ends, but a page that was watching still plays that hand out and then
// shows the winner's screen; "the tournament has ended" must not give the result away before
// that. The winner's screen (views/Tournaments.tsx) decides when; the table and the header wait.
import { useSyncExternalStore } from 'react';

const revealed = new Set<string>();
const listeners = new Set<() => void>();

export function markFinishRevealed(tournamentId: string): void {
  if (revealed.has(tournamentId)) return;
  revealed.add(tournamentId);
  for (const l of listeners) l();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => void listeners.delete(listener);
}

export function useFinishRevealed(tournamentId: string | undefined): boolean {
  return useSyncExternalStore(subscribe, () => !!tournamentId && revealed.has(tournamentId));
}
